/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Avatar, Col, Popover, Row } from 'antd';
import DefaultModal from 'components/common/DefaultModal';
import ChangePasswordModal from 'components/UserInfo/ChangePasswordModal';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import useUserMenu from 'hooks/useUserMenu';
import React from 'react';
import UploadAvatarModal from 'routes/Profile/components/UploadAvatarModal';
import { RoleEnum } from 'types/user';

const UserProfile = () => {
  const {
    onChangePasswordCancel,
    resetPasswordModalVisible,
    userMenuOptions,
    onVisibleChange,
    popoverVisibility,
    smallAvatarURL,
    onAvatarClick,
    fullName,
    toggle,
    closeUploadModal,
    mainLocation,
    onLocationClick,
    LocationSelectComponent,
    onLocationModalCancel,
    locationModalVisibility,
    locations,
  } = useUserMenu();

  const isMoreThanOneLocation = (locations?.length || 0) > 1;
  const doesLocationExist = locations?.length;
  const { role } = useCurrentLoggedInUser();
  const isUserClient = role === RoleEnum.CLIENT;

  return (
    <div className='gx-flex-row gx-align-items-center gx-avatar-row'>
      <DefaultModal
        props={{
          visible: locationModalVisibility,
          onCancel: onLocationModalCancel,
          title: 'Set Current Office Location',
        }}>
        <LocationSelectComponent />
      </DefaultModal>
      <ChangePasswordModal onCancel={onChangePasswordCancel} visible={resetPasswordModalVisible} />

      <Row wrap={false} align='middle' style={{ flexWrap: 'nowrap' }}>
        <Col onClick={(e) => onAvatarClick(e)}>
          <Avatar src={smallAvatarURL} className='gx-size-40 gx-pointer gx-mr-3' alt='' />
        </Col>
        <Col className='gx-d-flex flex-col' flex={1}>
          <Popover
            placement='bottomRight'
            trigger='click'
            content={userMenuOptions}
            onVisibleChange={onVisibleChange}
            visible={popoverVisibility}>
            <div className='cursor-pointer text-base hover:text-secondary-color'>
              <span className='gx-avatar-name'>{fullName}</span>
              <span style={{ minWidth: 12 }} className='gx-ml-2'>
                <i className='icon icon-chevron-down gx-fs-xxs' />
              </span>
            </div>
          </Popover>
          {isUserClient && (
            <div
              onClick={isMoreThanOneLocation || (!mainLocation && doesLocationExist) ? onLocationClick : undefined}
              className={`text-sm opacity-75 pt-2 ${
                isMoreThanOneLocation || (!mainLocation && doesLocationExist)
                  ? 'hover:text-secondary-color cursor-pointer'
                  : ''
              }`}>
              <span>{mainLocation ? mainLocation.name : 'Set Current Office Location'}</span>
            </div>
          )}
        </Col>
      </Row>
      <UploadAvatarModal visible={toggle} onCloseModal={closeUploadModal} />
    </div>
  );
};

export default UserProfile;
